import axios from "axios"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export interface MenuDto {
  menuId: string
  tenantId: string
  code: string
  label: string
  parentId?: string | null
  routePath?: string | null
  externalUrl?: string | null
  icon?: string | null
  sortOrder: number
  isActive: boolean
}

export interface MenuFilter {
  tenantId: string
  search?: string
  isActive?: boolean
  page?: number
  pageSize?: number
}

export interface MenuUpsertRequest {
  tenantId: string
  code: string
  label: string
  parentId?: string | null
  routePath?: string | null
  externalUrl?: string | null
  icon?: string | null
  sortOrder: number
  isActive: boolean
}

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export async function searchMenus(filter: MenuFilter): Promise<PagedResultDto<MenuDto>> {
  const response = await axios.get<PagedResultDto<MenuDto>>(buildUrl("/api/v1/menus"), { params: filter })
  return response.data
}

export async function createMenu(payload: MenuUpsertRequest): Promise<MenuDto> {
  const response = await axios.post<MenuDto>(buildUrl("/api/v1/menus"), payload)
  return response.data
}

export async function updateMenu(menuId: string, payload: MenuUpsertRequest): Promise<MenuDto> {
  const response = await axios.post<MenuDto>(buildUrl(`/api/v1/menus/${menuId}`), payload)
  return response.data
}

export async function setMenuActive(menuId: string, isActive: boolean): Promise<void> {
  await axios.patch(buildUrl(`/api/v1/menus/${menuId}/active`), null, { params: { isActive } })
}

export async function getMenu(menuId: string): Promise<MenuDto> {
  const response = await axios.get<MenuDto>(buildUrl(`/api/v1/menus/${menuId}`))
  return response.data
}
